<template>

  <div class="appeal-list">
    <div style="background-color: #fff;">
      <!-- <van-notice-bar
      v-if="userInfo.schoolName=='南京信息工程大学'"
  left-icon="volume-o"
  mode="closeable"
  text="本学期跑步截止时间为2024年1月12日晚22：30。"
/> -->

<van-dropdown-menu>
  <van-dropdown-item v-model="value1" :options="option1"  @change="vanDropdownChange"/>
  <van-dropdown-item v-model="value2" :options="option2"  @change="vanDropdownChange"/>
</van-dropdown-menu>
    <div class="top">
 <van-row>
  <van-col span="8">
    <div style="line-height: 40px;">
      {{scoreObj.completedTimes}}</div>
      <div >已完成</div>
  </van-col>
  <van-col span="8">
    <div  style="line-height: 40px;">
      {{scoreObj.incompleteTimes}}</div>
    <div >未完成</div>
  </van-col>
  <van-col span="8">
    <div  style="line-height: 40px;">
      {{scoreObj.requireNumber}}</div>
    <div >达标要求</div>
  </van-col>
</van-row>
    </div>
</div>
    

    <section class="appeal-list-warp">
      <div v-if="list.length">
        <div class="item" v-for="(item, index) of list" :key="index" >

          <div class="item-li">
            <div class="item-li-left">
              <div style="font-size:16px;font-weight:500;">{{ formatDate(item.runTime, 'DD') }}日</div>
              <div style="color:#B8B8B8;">{{ formatDate(item.runTime, 'MM') }}月</div>
            </div>
            <div  class="item-li-right">
              <div>
              <van-row>
                  <van-col span="18">
                    <span style="color:#B8B8B8;">阳光跑 <span style="font-size:13px;">{{item.startTmie||''}} ~ {{item.endTmie||''}}</span></span>
                  </van-col>
                  <van-col span="6">
                    <span class="right" :class="`bg${item.status}`">{{ SetValue(item.status) }}</span>
                  </van-col>
              </van-row>
            </div>
            <div >
                <div style="font-size:12px;color:red;" v-if="+item.status == 0">
                    <van-row>
                  <van-col span="18">
                  </van-col>
                  <van-col span="6">
                    {{SetwarnType(item.warnType)}}
                  </van-col>
              </van-row>
                </div>
                <div  v-if="+item.flag==1" class="mileageStyle">{{item.mileage}}m</div>
                <div v-else-if="+item.flag==2"  class="mileageStyleV2">成绩补录</div>
                <div v-else-if="+item.flag==0"  class="mileageStyleV2">app提交申诉</div>
                <div v-else-if="+item.flag==3"  class="mileageStyleV2">
                  微信公众号提交申诉
                </div>
            </div>
            <div>
              <van-row>
                  <van-col span="12">
                    <van-icon name="underway" color="#378AF9"/>用时：
                    <span style="color:#B8B8B8;" v-if="+item.flag==1">{{item.usedTime||'--'}}</span>
                    <span style="color:#B8B8B8;" v-else>- -</span>
                  </van-col>
                  <van-col span="12">
                    <van-icon name="fire" color="#DE704F"/>消耗：
                    <span style="color:#B8B8B8;"  v-if="+item.flag==1">{{item.calorie||'--'}}</span>
                    <span style="color:#B8B8B8;" v-else>- -</span>
                  </van-col>
              </van-row>
            </div>
            </div>
          </div>
         
            
          




          
      
        </div>
      </div>
      <van-empty v-else description="未查询到成绩数据" image-size="100" />
    </section>
  </div>
</template>
<script setup>
import { Empty as VanEmpty,Dialog ,Notify} from 'vant';
import { computed, onBeforeMount, ref } from 'vue';
import { getSchoolMonthByTerm,getTermList,getSunrunArch} from '@/api/sunrun/score.js';
import { setSessionJSON, getSessionJSON } from "@/utils/cookie.js"

import moment from 'moment';
const list = ref([]);
const scoreObj = ref({});

const option1 = ref([]);
const option2 = ref([]);

const value1 = ref('');
const value2 = ref('');

const projectActive = ref('阳光跑');
const ButtonList = [{ text: '新增申诉', type: 2 }];
const userInfo = computed(() => JSON.parse(sessionStorage.getItem('studentTitleCard')));
const SetValue = computed(() => {
  return (type) => {
    const obj = {
      0: '不合格',
      1: '合格',
      2: '申诉合格',
      3: '补录合格',
    };
    return obj[type];
  };
});
const SetwarnType = computed(() => {
  return (type) => {
    const obj = {
      1: '步数异常',
      2: '人脸异常',
      3: '拟合度异常',
    };
    return obj[type];
  };
});



const projectActiveClick = (name, title) => {
  console.log(name,title);
  console.log(projectActive.value);
  getSunrunArchFn()
  // console.log('我是新增');
};

function vanDropdownChange(){
  getSunrunArchFn()
}

const CustomClick = () => {
  this.$router.push('/appeal');
  // console.log('我是新增');
};
const JumpDetails = (item) => {
  // this.$router.push('/appeal/' + id + '');
  if (+item.flag==1) {
    this.$router.push({
    path:'/scoreInfo',
    query:{
      id:item.scoreId,
    }
  });

  setSessionJSON('scoreHomeData',{value1:value1.value,value2:value2.value})
  
  }else{
    Notify({
      type: 'warning',
      message: '申诉数据暂无详情页！',
    });
  }

};
function formatDate(datestr = new Date(), formart = 'yyyy年MM月DD日') {
    return moment(datestr).format(formart);
}
function getSunrunArchFn() {
  console.log(userInfo.value);



  getSunrunArch({projectName:projectActive.value, 
  monthId:value1.value,
  termId:value2.value,
  stuNumber: userInfo.value.snCode,  snCode: userInfo.value.snCode,schoolCode: userInfo.value.schoolCode, pageNumber: 1, rowNumber: 100000 }).then((res) => {

scoreObj.value = {requireNumber:res.data.requireNumber,
completedTimes:res.data.completedTimes,
incompleteTimes:res.data.incompleteTimes}
   list.value = res.data.data;
  });


}

async function  getSchoolMonthByTermFn () {
  
 await getSchoolMonthByTerm({
  schoolCode: userInfo.value.schoolCode,
    }).then((res) => {
      res.data.monthList?.forEach(el=>{
        if (+el.ifCurrent==1) {
          value1.value = el.monthId
        }
        el.text = el.monthName
        el.value = el.monthId
      })
    option1.value = res.data.monthList;
  });
 await getTermList({
  schoolCode: userInfo.value.schoolCode,
    }).then((res) => {
      res.data.termList?.forEach(el=>{
         if (+el.isActive==1) {
          value2.value = el.code
        }
        el.text = el.name
        el.value = el.code
      })
    option2.value = res.data.termList;
  });
  var scoreHomeData =getSessionJSON('scoreHomeData') 
  console.log(scoreHomeData);
if (scoreHomeData&&scoreHomeData.value1) {
  value1.value = scoreHomeData.value1
  value2.value = scoreHomeData.value2
}



}


onBeforeMount(async () =>  {



if(!userInfo.value.snCode||userInfo.value.snCode==''){
  return
}

 await getSchoolMonthByTermFn()
 await getSunrunArchFn()
});
</script>
<style lang="less" scoped>
.appeal-list {
  font-size: 14px;
    .top {
      background-image: url(../../../assets/background/fitnessAchievement.jpg);
      height: 85px;
      width: 90%;
      margin: 20px auto;
      padding-top: 15px;
      border-radius: 15px;
      box-shadow: 0px 1px 6px 0px #eef1fc;
      position: relative;
      text-align: center;
      color: #fff;
     
    }
    .mileageStyle{
      font-size: 21px;
      margin: 12px 0;
    }
    .mileageStyleV2{
      font-size: 16px;
      margin: 12px 0;
      text-align: center;

    }
  display: flex;
  flex-direction: column;
  &-warp {
    flex: 1;
    overflow: scroll;
    padding: 0px 10px;
    .item {
      margin-top: 15px;
   
  .item-li{
    display: flex;

    .item-li-left{
      width: 18%;
      text-align: center;
      margin: auto;
    }
    .item-li-right{
      background: #ffffff;
      box-shadow: 0px 1px 6px 0px #eef1fc;
      border-radius: 10px;
      padding: 12px;
      width: 82%;
      display: flex;
      flex-direction: column;
    }
  }


      .right {
          font-size: 16px;
          font-weight: 500;
        
          &.bg0 {
            // background: #ffecde;
            color: #ff5600;
          }
          &.bg1 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg2 {
            // background: #e4f2ff;
            color: #007ff0;
          }
          &.bg3 {
            // background: #ffe9eb;
            color: #ff0000;
          }
        }
    }
  }
  .footer {
    display: flex;
    margin-bottom: 3%;
    margin-top: 5%;
    justify-content: space-around;
    /deep/.van-button {
        
      flex-basis: 80%;
    }
  }
}
</style>
